import React, { useState } from 'react';
import dialogCreators from './dialogs';

export const DialogContext = React.createContext(undefined);

const DialogProvider: React.FC = (props) => {
    const [dialog, setDialog] = useState<React.ReactElement>(undefined);
    const [beginHide, setBeginHide] = useState(false);

    const hideDialog = () => {
        setBeginHide(true);
        window.setTimeout(() => {
            setDialog(undefined);
            setBeginHide(false);
        }, 500);
    };

    React.useEffect(() => {
        const overflowSetting = dialog ? 'hidden' : 'inherit';
        const paddingRight = dialog ? '15px' : '0';
        document.getElementsByTagName('html')[0].style.overflowY = overflowSetting;
        const nav = document.getElementById('root');
        const navBar = nav.getElementsByClassName('app-navbar')[0];
        if (navBar) {
            (navBar as HTMLElement).style.paddingRight = paddingRight;
        }
        const secondNavBar = nav.getElementsByClassName('app-second-navbar')[0];
        if (secondNavBar) {
            (secondNavBar as HTMLElement).style.paddingRight = paddingRight;
        }
    }, [dialog]);

    const showDialog = () => {
        const hookedDialog = React.cloneElement(dialog, { ...dialog.props, onCloseDialog: hideDialog });
        return hookedDialog;
    };

    return (
        <DialogContext.Provider value={{ ...dialogCreators(setDialog, hideDialog, beginHide) }}>
            {dialog && showDialog()}
            {props.children}
        </DialogContext.Provider>
    );
};

export default DialogProvider;
export { dialogCreators } from './dialogs';



// WEBPACK FOOTER //
// ./src/providers/DialogProvider.tsx